import { render } from "./Optout.vue?vue&type=template&id=2da0adf2&scoped=true"
import script from "./Optout.vue?vue&type=script&lang=js"
export * from "./Optout.vue?vue&type=script&lang=js"

import "./Optout.vue?vue&type=style&index=0&id=2da0adf2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da0adf2"]])

export default __exports__